import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';
import Link from 'next/link';

const featuredAudio = [
{
  id: 1,
  title: "Women of Faith: Ruth\'s Journey",
  speaker: "Dr. Sarah Martinez",
  duration: "45 min",
  category: "Bible Study",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d7b33ab2-1763298879110.png",
  alt: "Mature Hispanic woman with warm smile wearing earth-tone sweater in cozy library setting",
  description: "Explore the profound faith and loyalty of Ruth through a feminine lens of biblical interpretation."
},
{
  id: 2,
  title: "Psalms for Modern Mothers",
  speaker: "Rev. Michelle Chen",
  duration: "32 min",
  category: "Devotional",
  image: "https://images.unsplash.com/photo-1731067351020-3af55c91bb1e",
  alt: "Young Asian mother reading book while sitting peacefully in sunlit room with plants",
  description: "Finding strength and peace in the Psalms for today\'s busy mothers and caregivers."
},
{
  id: 3,
  title: "The Feminine Divine in Scripture",
  speaker: "Prof. Rebecca Thompson",
  duration: "58 min",
  category: "Theology",
  image: "https://images.unsplash.com/photo-1723452758962-b85dccff0b4b",
  alt: "Professional woman with curly hair in thoughtful pose holding open book in academic setting",
  description: "Discovering the feminine aspects of God\'s nature throughout biblical texts and traditions."
}];


const liveStreams = [
{
  id: 1,
  title: "Morning Prayer & Meditation",
  time: "6:00 AM EST",
  status: "live",
  viewers: 1247,
  image: "https://images.unsplash.com/photo-1566874515902-314180c136db",
  alt: "Serene sunrise over calm lake with mountains reflecting golden light on water surface"
},
{
  id: 2,
  title: "Women\'s Bible Study Circle",
  time: "7:30 PM EST",
  status: "upcoming",
  viewers: 892,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ebcb30cd-1765178629865.png",
  alt: "Circle of diverse women sitting together with open Bibles in warm candlelit room"
},
{
  id: 3,
  title: "Contemplative Worship",
  time: "9:00 PM EST",
  status: "upcoming",
  viewers: 654,
  image: "https://images.unsplash.com/photo-1499824449434-bd649810e127",
  alt: "Peaceful chapel interior with soft candlelight and stained glass windows casting colorful patterns"
}];


export default function FeaturedContent() {
  return (
    <section className="py-16 bg-surface">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-crimson font-semibold text-foreground mb-4">
            Featured Spiritual Content
          </h2>
          <p className="text-lg text-muted-foreground font-source-serif max-w-2xl mx-auto">
            Discover inspiring audio teachings and join live spiritual gatherings 
            designed to nurture your faith journey.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Featured Audio */}
          <div>
            <div className="flex items-center mb-6">
              <Icon name="SpeakerWaveIcon" size={24} className="text-primary mr-3" />
              <h3 className="text-2xl font-crimson font-semibold text-foreground">
                Featured Audio
              </h3>
            </div>

            <div className="space-y-4">
              {featuredAudio?.map((audio) =>
              <Link
                key={audio?.id}
                href="/audio-book-library"
                className="block bg-card rounded-xl p-4 border border-border hover-lift contemplative-transition cursor-pointer">

                  <div className="flex gap-4">
                    <div className="flex-shrink-0 w-20 h-20 rounded-lg overflow-hidden">
                      <AppImage
                      src={audio?.image}
                      alt={audio?.alt}
                      className="w-full h-full object-cover" />

                    </div>
                    
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 mb-1">
                        <span className="inline-block px-2 py-1 text-xs font-inter font-medium bg-primary/10 text-primary rounded">
                          {audio?.category}
                        </span>
                        <span className="text-xs text-muted-foreground font-inter">
                          {audio?.duration}
                        </span>
                      </div>
                      
                      <h4 className="font-inter font-semibold text-foreground mb-1 truncate">
                        {audio?.title}
                      </h4>
                      
                      <p className="text-sm text-muted-foreground font-source-serif mb-2 line-clamp-2">
                        {audio?.description}
                      </p>
                      
                      <p className="text-sm text-primary font-inter">
                        by {audio?.speaker}
                      </p>
                    </div>
                    
                    <button className="flex-shrink-0 w-10 h-10 rounded-full bg-primary/10 text-primary flex items-center justify-center hover:bg-primary hover:text-primary-foreground contemplative-transition">
                      <Icon name="PlayIcon" size={16} />
                    </button>
                  </div>
                </Link>
              )}
            </div>

            <Link
              href="/audio-book-library"
              className="block w-full mt-6 py-3 text-center text-primary font-inter font-medium border border-primary rounded-lg hover:bg-primary hover:text-primary-foreground contemplative-transition">

              Browse All Audio Content
            </Link>
          </div>

          {/* Live Streams */}
          <div>
            <div className="flex items-center mb-6">
              <Icon name="VideoCameraIcon" size={24} className="text-primary mr-3" />
              <h3 className="text-2xl font-crimson font-semibold text-foreground">
                Live Streams
              </h3>
            </div>

            <div className="space-y-4">
              {liveStreams?.map((stream) =>
              <Link
                key={stream?.id}
                href="/live-streams-hub"
                className="block bg-card rounded-xl p-4 border border-border hover-lift contemplative-transition cursor-pointer">

                  <div className="flex gap-4">
                    <div className="flex-shrink-0 w-20 h-20 rounded-lg overflow-hidden relative">
                      <AppImage
                      src={stream?.image}
                      alt={stream?.alt}
                      className="w-full h-full object-cover" />

                      {stream?.status === 'live' &&
                    <div className="absolute top-2 left-2 px-2 py-1 bg-error text-error-foreground text-xs font-inter font-medium rounded">
                          LIVE
                        </div>
                    }
                    </div>
                    
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 mb-1">
                        <span className="text-sm font-inter font-medium text-foreground">
                          {stream?.time}
                        </span>
                        {stream?.status === 'live' &&
                      <div className="flex items-center text-xs text-muted-foreground">
                            <Icon name="EyeIcon" size={12} className="mr-1" />
                            {stream?.viewers?.toLocaleString()}
                          </div>
                      }
                      </div>
                      
                      <h4 className="font-inter font-semibold text-foreground mb-2">
                        {stream?.title}
                      </h4>
                      
                      <div className="flex items-center gap-2">
                        {stream?.status === 'live' ?
                      <span className="px-4 py-2 bg-primary text-primary-foreground text-sm font-inter font-medium rounded-lg">
                            Join Now
                          </span> :

                      <span className="px-4 py-2 bg-surface text-foreground text-sm font-inter font-medium rounded-lg border border-border">
                            Set Reminder
                          </span>
                      }
                      </div>
                    </div>
                  </div>
                </Link>
              )}
            </div>

            <Link
              href="/live-streams-hub"
              className="block w-full mt-6 py-3 text-center text-primary font-inter font-medium border border-primary rounded-lg hover:bg-primary hover:text-primary-foreground contemplative-transition">

              View Full Schedule
            </Link>
          </div>
        </div>
      </div>
    </section>);

}